import React from "react";
import { Props } from "@/redux/interfaces/page";
import AuthManager from "@/redux/slice/auth/container/AuthManager";
import Header from "@/components/Header";
import Footer from "@/components/footer";
import BottomNavigation from "@/components/BottomNavigation";
import SignIn from "@/components/SignIn";
import LocationManager from "@/redux/slice/location/components/LocationManager";
import CartManager from "@/redux/slice/cart/container/CartManager";
import UserDataManager from "@/redux/slice/auth/container/UserDataManager";

const Main: React.FC<Props> = ({ children, pageProps, serverPathname }) => {
  const { ua, isUserFromApp } = pageProps;

  return (
    <>
      <AuthManager ua={ua}>
        <UserDataManager>
          <CartManager />
          <LocationManager />
          {<Header pageProps={pageProps} />}
          {children}
          {!isUserFromApp && <Footer />}
          {!ua?.isDesktop && <BottomNavigation serverPathname={serverPathname} />}
          <SignIn ua={ua} />
        </UserDataManager>
      </AuthManager>
    </>
  );
};

export default Main;
